(function(){
  var root=document.documentElement;
  root.classList.add('bcb-bb-js');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(el){el.classList.add('is-in')}
  function init(){
    var els=document.querySelectorAll('[data-bb-reveal],[data-bb-stagger],.bcb-bb-hero');
    if(reduce||!('IntersectionObserver' in window)){els.forEach(show);return}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.12});
    els.forEach(function(el){io.observe(el)});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('click',function(e){
    var close=e.target.closest('[data-bb-close]');
    var link=e.target.closest('.bcb-bb-drawer a');
    var menu=document.querySelector('.bcb-bb-menu[open]');
    if(menu&&(close||link||(!e.target.closest('.bcb-bb-drawer')&&!e.target.closest('.bcb-bb-menu>summary')))){menu.removeAttribute('open')}
  });
  document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;var m=document.querySelector('.bcb-bb-menu[open]');if(m){m.removeAttribute('open');var s=m.querySelector('summary');if(s)s.focus()}});
})();
/* Country scene: layers drift, sun sets and the truck drives across as you scroll */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v){return v<0?0:v>1?1:v}
  function ease(t){return 1-Math.pow(1-t,3)}
  function init(){
    var root=document.querySelector('[data-bb-scene]'); if(!root) return;
    var svg=root.querySelector('.bb-scene'), track=root.querySelector('.bcb-bb-track'), pin=root.querySelector('.bcb-bb-pin');
    var content=root.querySelector('.bcb-bb-hero-content'), truck=svg.querySelector('.bb-scene-truck'), dust=svg.querySelector('.bb-scene-dust');
    var L={}; svg.querySelectorAll('[data-bb-layer]').forEach(function(el){L[el.getAttribute('data-bb-layer')]=el});
    var header=document.querySelector('.bcb-bb-header'), head=58, intro=reduce?1:0, introStart=null, queued=false;
    function measure(){head=header?header.offsetHeight:58;document.documentElement.style.setProperty('--bb-head',head+'px')}
    function view(){var r=svg.getBoundingClientRect();var s=Math.max(r.width/1600,r.height/1000)||1;var w=r.width/s;return {left:800-w/2,w:w}}
    function progress(){if(reduce)return 0;var r=track.getBoundingClientRect();var total=r.height-pin.offsetHeight;return total>0?clamp((head-r.top)/total):0}
    function t(el,v){if(el)el.style.transform=v}
    function render(){
      queued=false;
      var p=progress(), v=view();
      t(L.sun,'translate(0px,'+(p*190)+'px)');
      t(L.birds,'translate('+(p*160)+'px,'+(-p*50)+'px)');
      t(L.far,'translate('+(-p*40)+'px,0px)');
      t(L.mid,'translate('+(-p*110)+'px,0px)');
      t(L.field,'translate('+(-p*200)+'px,0px)');
      t(L.fence,'translate('+(-p*380)+'px,0px)');
      t(L.grass,'translate('+(-p*480)+'px,0px)');
      if(L.dusk)L.dusk.style.opacity=(p*.55).toFixed(3);
      var narrow=v.w<900, start=narrow?v.left-90:v.left+v.w*.06, end=narrow?v.left+v.w-150:v.left+v.w*.94-292;
      if(reduce){start=end=800-146}
      var x=start+(end-start)*p, from=v.left-360;
      x=from+(x-from)*ease(intro);
      var bob=reduce?0:Math.sin((p*40)+(intro*12))*1.6;
      t(truck,'translate('+x.toFixed(1)+'px,'+bob.toFixed(2)+'px)');
      if(dust)dust.style.opacity=reduce?0:Math.min(1,.35+p*2);
      if(content)t(content,'translateY('+(-p*36)+'px)');
    }
    function queue(){if(!queued){queued=true;requestAnimationFrame(render)}}
    function introStep(ts){if(introStart===null)introStart=ts;intro=clamp((ts-introStart)/1600);render();if(intro<1)requestAnimationFrame(introStep)}
    measure();render();
    if(!reduce)requestAnimationFrame(introStep);
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',function(){measure();queue()});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
